import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { PlanesCuotasController } from './planes-cuotas.controller';
import { PlanesCuotasService } from './planes-cuotas.service';

@Module({
  imports: [PrismaModule],
  controllers: [PlanesCuotasController],
  providers: [PlanesCuotasService],
  exports: [PlanesCuotasService],
})
export class PlanesCuotasModule {}
